<mat-form-field>
  <mat-label>Gruppi di allenamento</mat-label>
  <mat-select [formControl]='control' multiple>
    <mat-option *ngFor='let value of values' [value]='value.Oid'>{{value.BusinessName}}</mat-option>
  </mat-select>
</mat-form-field>
